import { isNil } from "lodash"
import { ConstraintConstant } from "./constant"

export function isValidNumber(input) {
    if (isNil(input)) {
        return false
    }

    return ConstraintConstant.NUMBERIC_PATTERN.test(input)
}